// extracted by mini-css-extract-plugin
module.exports = {"confirm":"Signup_confirm__pGF8U"};